"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ImageIcon = function ImageIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 256 256",
    role: "img",
    "aria-label": "Image file icon"
  }, props), _react.default.createElement("path", {
    d: "M232 0H24C10.77 0 0 10.77 0 24v208c0 13.23 10.77 24 24 24h208c13.23 0 24-10.77 24-24V24c0-13.23-10.77-24-24-24zm0 24l.01 137.09a123.358 123.358 0 0 0-42.51-7.58c-18.97 0-37.76 4.44-54.73 12.84l-43.88-48.41a12.018 12.018 0 0 0-8.6-3.94c-3.28-.08-6.46 1.19-8.78 3.51L24 167.03V24h208zM24 200.97l57.57-57.57 80.31 88.6H24v-31.03zM232 232h-37.73l-42.6-47c25.88-10.74 54.86-10.06 80.34 2.07v44.92c.01.01 0 .01-.01.01z"
  }), _react.default.createElement("path", {
    d: "M172 120c19.85 0 36-16.15 36-36s-16.15-36-36-36-36 16.15-36 36 16.15 36 36 36zm0-48c6.62 0 12 5.38 12 12s-5.38 12-12 12-12-5.38-12-12 5.38-12 12-12z"
  }));
};

ImageIcon.displayName = 'ImageIcon';
ImageIcon.propTypes = {
  size: _propTypes.number
};
ImageIcon.defaultProps = {
  size: 40
};
var _default = ImageIcon;
exports.default = _default;